import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, apiErrorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function NewsletterModal({ open, onOpenChange, source = "other" }) {
  const { user } = useAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", {
        email: user ? undefined : email,
        source,
        url: window.location.href,
      });
      toast.success("Готово! Благодарим за абонамента.");
      onOpenChange(false);
      setEmail("");
    } catch (err) {
      toast.error(apiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md border-t-4 border-t-[#C47A35]" data-testid="newsletter-modal">
        <DialogHeader>
          <DialogTitle className="font-serif text-3xl text-[#10243A]">Metri.bg Бюлетин за новини</DialogTitle>
          <DialogDescription className="text-[#66717B] text-base">
            Най-важното от имотния пазар, инвестициите и лихвите — веднъж седмично в пощата ви.
          </DialogDescription>
        </DialogHeader>
        <p className="text-xs font-semibold uppercase tracking-wide text-[#A6631F]">Читатели вече се абонираха тази седмица</p>
        <form onSubmit={submit} className="space-y-3 pt-1">
          {!user && (
            <Input
              type="email"
              required
              placeholder="Вашият имейл"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-12 text-base"
              data-testid="newsletter-email-input"
            />
          )}
          {user && <p className="text-sm text-[#66717B]">Ще използваме имейла на профила ви: {user.email}</p>}
          <Button
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-[#10243A] hover:bg-[#C47A35] text-white text-base font-semibold transition-colors"
            data-testid="newsletter-submit-btn"
          >
            {loading ? "Изпращане..." : "Абонирай се"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
